export default "__VITE_ASSET__91zaq26c__"